<template>
  <div class="mt-md-3 mx-md-8 mx-lg-16">
    <v-card flat>
      <v-card-title>
        Neue Buchung Erzeugen
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-row class="mx-0">
          <div style="width: 600px" class="mr-md-12">
            <booking-editor ref="bookingEditor"> </booking-editor>
          </div>
        </v-row>
      </v-card-text>
      <v-divider class="mt-3" />
      <v-card-actions>
        <v-btn color="primary" elevation="0" @click="doBookingSubmission()">
          Erstellen
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import BookingEditor from "@/components/financial/BookingEditor";

export default {
  name: "BookingSubmission",
  components: { BookingEditor },
  methods: {
    ...mapActions("financial", ["submitBooking"]),
    doBookingSubmission() {
      if (this.$refs.bookingEditor.validate()) {
        let newBooking = this.$refs.bookingEditor.getBooking();
        this.submitBooking(newBooking);
        this.$router.push("/financial/bookings");
      } else {
        this.$vuetify.goTo(1, { duration: 650 });
      }
    }
  },
  computed: {
    ...mapGetters("user", ["isAdmin", "isStavo", "isTreasurer"]),
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    userInfo() {
      return this.$store.state.user.userInfo;
    }
  }
};
</script>

<style scoped></style>
